export interface PagedRequestDto {
  pageNumber?: number;
  pageSize?: number;
  searchTerm?: string | null;
  sortBy?: string | null;
  sortDescending?: boolean;
}
